module.exports = __webpack_public_path__ + "static/img/catPrototipagem.e8e8697.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catPrototipagem.svg
// module id = uEQE
// module chunks = 0